export default "__VITE_ASSET__Cyq72GYo__"